var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D97706"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1696 13.212L7.45579 9.81974C7.28686 9.60858 7.20239 9.50299 7.14233 9.38542C7.08904 9.28111 7.05009 9.17008 7.02654 9.05534C7 8.92601 7 8.7908 7 8.52038V8.08C7 7.35193 7 6.9879 7.14169 6.70981C7.26633 6.4652 7.4652 6.26633 7.70981 6.14169C7.9879 6 8.35193 6 9.08 6H15.32C16.0481 6 16.4121 6 16.6902 6.14169C16.9348 6.26633 17.1337 6.4652 17.2583 6.70981C17.4 6.9879 17.4 7.35193 17.4 8.08V8.52038C17.4 8.7908 17.4 8.92601 17.3735 9.05534C17.3499 9.17008 17.311 9.28111 17.2577 9.38542C17.1976 9.50299 17.1131 9.60858 16.9442 9.81974L14.2304 13.212M7.65003 6.65L12.2 12.5L16.75 6.65M14.4981 13.4519C15.7673 14.7211 15.7673 16.7789 14.4981 18.0481C13.2289 19.3173 11.1711 19.3173 9.9019 18.0481C8.6327 16.7789 8.6327 14.7211 9.9019 13.4519C11.1711 12.1827 13.2289 12.1827 14.4981 13.4519Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.5f44e059ae80ac2f6b779d2e351993ac.svg";
export { ForwardRef as ReactComponent };